import { morphism } from 'morphism';
import { createStrictSchema } from '../../utils/morph.js';
import { itemGeoSchema } from '../geo/morph.js';

const itemImageSchema = createStrictSchema({
    cdnBaseUrl: 'cdn_base_url',
});
const itemCategorySchema = createStrictSchema({
    id: 'key',
    label: 'value',
    parentId: 'macrocategory_id',
    friendlyName: 'friendly_name',
    weight: 'weight',
});
const itemAdvertiserSchema = createStrictSchema({
    name: 'name',
    type: 'type',
    phone: 'phone',
    userId: 'user_id',
    company: 'company',
    shopId: {
        path: 'shop_id',
        // from number to string
        fn: (shop_id) => typeof shop_id !== 'undefined' ? `${shop_id}` : shop_id,
    },
    shopName: 'shop_name',
    proTransactionsEnabled: 'pro_transactions_enabled',
    proPremiumDetailEnabled: 'pro_premium_detail_enabled',
});
const itemVisibilityOptionsSchema = createStrictSchema({
    gallery: 'gallery',
    urgent: 'urgent',
    smartbumpedAt: 'smartbumped_at',
    bounce: 'bounce',
    autoBounce: 'auto_bounce',
    geoBoost: 'geoboost',
    morePhotos: 'more_photos',
    homepageRecommender: 'homepage_recommender',
    detailRecommender: 'detail_recommender',
});
const itemSchemaObj = {
    kind: () => 'AdItem',
    urn: 'urn',
    type: 'type',
    category: {
        path: 'category',
        fn: morphism(itemCategorySchema),
    },
    subject: 'subject',
    body: 'body',
    date: 'dates.display',
    images: {
        path: 'images',
        fn: morphism(itemImageSchema),
    },
    features: {
        path: 'features',
        fn: (features) => features.reduce((feats, rawFeature) => ({
            ...feats,
            [rawFeature.uri]: rawFeature,
        }), {}),
    },
    advertiser: {
        path: 'advertiser',
        fn: morphism(itemAdvertiserSchema),
    },
    geo: {
        path: 'geo',
        fn: morphism(itemGeoSchema),
    },
    visibilityOptions: {
        path: 'visibility_options',
        fn: morphism(itemVisibilityOptionsSchema),
    },
    urls: 'urls',
};
const itemSchema = createStrictSchema(itemSchemaObj);
const gallerizedItemSchema = createStrictSchema({
    ...itemSchemaObj,
    gallerized: () => true,
});
const singleAdSchema = (body) => {
    if (body instanceof Object &&
        'ads' in body &&
        Array.isArray(body.ads) &&
        body.ads.length === 1) {
        return morphism(itemSchema, body.ads[0]);
    }
    throw new Error('Result did not contain a single ad as expected');
};
const adOwnerVerificationSchema = createStrictSchema({
    userID: 'user_id',
    listID: 'list_id',
    isOwner: 'is_owner',
});
const correlatedTrackingInfo = createStrictSchema({
    transactionID: 'transaction-id',
    listName: 'list-name',
    itemID: 'item-id',
});
const correlatedAdsIdsSchema = createStrictSchema({
    ids: 'related-items',
    trackingInfo: {
        path: 'tracking-info',
        fn: morphism(correlatedTrackingInfo),
    },
});
const searchExtrasSchema = {
    advertiserTypeFacets: 'advertiser_facet.advertiser_type',
};
const userAdSchema = createStrictSchema({
    ...itemSchemaObj,
    editUrl: 'edit_url',
    expiresIn: 'expires_in',
    statistics: 'statistics',
    paidOptions: 'paid_options',
});
const userAdsSchema = createStrictSchema({
    total: 'count_all',
    checkNew: 'checknew',
    lines: 'lines',
    start: 'start',
    ads: {
        path: 'ads',
        fn: morphism(userAdSchema),
    },
    filterLabels: 'filters',
    extras: {
        path: 'extra',
        fn: morphism(searchExtrasSchema),
    },
});

export { adOwnerVerificationSchema, correlatedAdsIdsSchema, correlatedTrackingInfo, gallerizedItemSchema, itemAdvertiserSchema, itemCategorySchema, itemSchema, itemVisibilityOptionsSchema, singleAdSchema, userAdSchema, userAdsSchema };
//# sourceMappingURL=morph.js.map
